import { Api } from '@/services/Api'

export default {
  getAllPages(plantId) {
    return Api().get(`/api/v1.0/plantPages/${plantId}`)
  },
  getHeaderInfo(payload) {
    return Api().post(`/api/v1.0/headerInfo`, payload)
  }
}
